<template>
  <div id="map-page">
    <SearchFilter @update="onFilterUpdate" />
    <div class="map-container">
      <l-map
        ref="map"
        :center="map.center"
        :zoom="map.zoom"
        :maxZoom="map.maxZoom"
        @leaflet:load="onMapLoaded"
        @update:bounds="updateBounds"
      >
        <l-marker-cluster>
          <l-marker
            v-for="exp in experiences"
            :key="exp.id"
            :lat-lng="exp.latLng"
            @click="() => openMapPopup(exp)"
          />
        </l-marker-cluster>
        <l-tile-layer :url="map.url"></l-tile-layer>
      </l-map>
    </div>
    <MapResult :experiences="experiences" :snapshots="snapshots" />
  </div>
</template>

<script>
import SearchFilter from "@/components/SearchFilter";
import MapResult from "@/components/MapResult";
import ExperienceService from "@/services/experience";
import axios from "axios";
import { latLng } from "leaflet";

export default {
  name: "MapPage",
  components: {
    SearchFilter,
    MapResult,
  },
  data() {
    return {
      map: {
        url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
        zoom: 4,
        maxZoom: 18,
        center: [47.13, 104],
        bounds: null,
        zoomControl: false,
      },
      filter: {
        search: "",
        travelerTypes: [],
        categories: [],
      },
      experiences: [],
      snapshots: [],
    };
  },
  methods: {
    onSearchUpdated(filter) {
      this.filter = filter;
      this.loadData();
    },
    getBoundsData(bounds) {
      const southWest = bounds.getSouthWest();
      const northEast = bounds.getNorthEast();
      return { southWest, northEast };
    },
    onMapLoaded() {
      const bounds = this.$refs.map.mapObject.getBounds();
      this.bounds = this.getBoundsData(bounds);
      this.loadData();
    },
    updateBounds(bounds) {
      this.bounds = this.getBoundsData(bounds);
      this.loadData();
    },
    loadData() {
      this.loadExperiences(this.bounds, this.filter);
      this.loadSnapshots(this.bounds);
    },
    loadExperiences(
      { southWest, northEast },
      { search, categories, travelerTypes }
    ) {
      const url = process.env.VUE_APP_API_URI;
      const postData = {
        query: `query experiencesInRegion($sw: [Float!]!, $ne: [Float!]!, $search: String, $categories: [ID], $travelerTypes: [ID]) {
          experiencesInRegion(sw: $sw, ne: $ne, search: $search, categories: $categories, travelerTypes: $travelerTypes) {
              id name title description thumbnailUrl address websiteLink telephone linkUrl position { lat lng }
            }
        }`,
        variables: {
          sw: [southWest.lat, southWest.lng],
          ne: [northEast.lat, northEast.lng],
          categories,
          travelerTypes,
          search,
        },
      };

      axios
        .post(url, postData, {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        })
        .then((res) => {
          const { experiencesInRegion } = res.data.data;
          experiencesInRegion.forEach((it) => {
            if (it.position) {
              it.latLng = latLng(it.position.lat, it.position.lng);
            }
          });
          this.experiences = experiencesInRegion;
        })
        .catch(console.error);
    },
    loadSnapshots(bounds) {
      const { southWest, northEast } = bounds;
      const url = `${process.env.VUE_APP_MOMENTS_URI}/campaigns/${process.env.VUE_APP_IMAGE_BOARD_ID}/posts?bounds=${southWest.lat},${southWest.lng},${northEast.lat},${northEast.lng}?per_page=999999`;

      axios
        .get(url)
        .then((res) => {
          this.snapshots = res.data.posts;
        })
        .catch(console.error);
    },
    openMapPopup(exp) {
      ExperienceService.openPopup(exp.id);
    },
    onFilterUpdate(filter) {
      this.filter = filter;
      this.loadData();
    },
  },
  mounted() {
    this.$refs.map.mapObject.zoomControl.remove();
  },
};
</script>

<style lang="scss" scoped>
#map-page {
  width: 100vw;
  height: 100vh;
  padding: 52px 0 0;
  overflow: hidden;

  .map-container {
    height: 100%;
  }
}
</style>
